import React, { useEffect, useState } from "react";
import { Container, Modal, Form, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { message, Modal as AntModal } from "antd";
import Footer from "../../../components/superAdmin/footer/Footer";
import SubAdminTable from "../../../components/subadmin/SubAdminTable";
import SubAdminHeader from "../components/SubAdminHeader";

const SubAdminAreas = () => {
    const navigate = useNavigate();
    const [areas, setAreas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [permissions, setPermissions] = useState(null);
    
    // Modals state
    const [showEdit, setShowEdit] = useState(false);
    const [editForm, setEditForm] = useState({});
    const [saving, setSaving] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('jff_token');
            const dashResponse = await axios.get(`${process.env.REACT_APP_API_END_POINT}/subadmin/dashboard`, {
                headers: { token }
            });
            const areaPerms = dashResponse.data.permissions.areaList;
            setPermissions(areaPerms);

            if (!areaPerms.enabled || !areaPerms.read) {
                navigate("/subadmin/dashboard");
                return;
            }

            const response = await axios.get(`${process.env.REACT_APP_API_END_POINT}/subadmin/areas`, {
                headers: { token }
            });
            setAreas(response.data.data);
        } catch (error) {
            console.error("Error fetching areas:", error);
            if (error.response && error.response.status === 403) {
                navigate("/subadmin/dashboard");
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [navigate]);

    const handleEdit = (item) => {
        setEditForm({ ...item });
        setShowEdit(true);
    };

    const handleUpdate = async () => {
        setSaving(true);
        try {
            const token = localStorage.getItem('jff_token');
            await axios.post(`${process.env.REACT_APP_API_END_POINT}/update-hall-stall-details`, {
                id: editForm._id,
                ...editForm
            }, {
                headers: { token }
            });
            message.success("Updated successfully");
            setShowEdit(false);
            fetchData();
        } catch (error) {
            message.error("Failed to update");
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = (id) => {
        AntModal.confirm({
            title: 'Are you sure you want to delete this area?',
            content: 'This action cannot be undone.',
            okText: 'Yes, Delete',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                try {
                    const token = localStorage.getItem('jff_token');
                    await axios.post(`${process.env.REACT_APP_API_END_POINT}/delete-hall-stall`, { id }, {
                        headers: { token }
                    });
                    message.success("Deleted successfully");
                    fetchData();
                } catch (error) {
                    message.error("Failed to delete");
                }
            }
        });
    };

    const handleStatusChange = async (item) => {
        try {
            const token = localStorage.getItem('jff_token');
            let newStatus = item.status === "active" ? "inactive" : "active";
            
            await axios.post(`${process.env.REACT_APP_API_END_POINT}/update-area-status`, 
                { id: item._id, status: newStatus },
                { headers: { token } }
            );
            
            message.success("Status updated successfully");
            fetchData();
        } catch (error) {
            console.error("Error updating status:", error);
            message.error("Failed to update status");
        }
    };

    return (
        <div style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
            <SubAdminHeader />

            <Container fluid className="px-0 py-5">
                <div className="text-center mb-4">
                    <h2 className="form-heading">Exhibition Areas - {areas.length}</h2>
                </div>
                <SubAdminTable 
                    data={areas}
                    columns={permissions?.columns || []}
                    loading={loading}
                    writeAccess={permissions?.write}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    onStatusChange={handleStatusChange}
                    tableName="Exhibition Areas"
                />
            </Container>

            <Modal show={showEdit} onHide={() => setShowEdit(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Area</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Hall Name</Form.Label>
                                    <Form.Control 
                                        value={editForm.hallName || ''} 
                                        onChange={(e) => setEditForm({ ...editForm, hallName: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Stall Number</Form.Label>
                                    <Form.Control 
                                        value={editForm.stallNumber || ''} 
                                        onChange={(e) => setEditForm({ ...editForm, stallNumber: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Block</Form.Label>
                                    <Form.Control 
                                        value={editForm.block || ''} 
                                        onChange={(e) => setEditForm({ ...editForm, block: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEdit(false)}>Cancel</Button>
                    <Button variant="primary" onClick={handleUpdate} disabled={saving}>
                        {saving ? 'Saving...' : 'Save Changes'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Footer />
        </div>
    );
};

export default SubAdminAreas;
